export default __webpack_public_path__ + "static/char-s-54-zh-Hans-e52a1f2be043d9cc53c80ff821d06e27.png";